import { css } from 'styled-components';

import { gradientA } from '#/colors';

export const MARKET_INFO_AREA_HEIGHT = '56px';

export const gradientUnderline = css`
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-image: ${gradientA};
    border-radius: 2px;
    box-shadow: 0 0 7px rgba(188, 68, 255, 0.7);
  }
`;
